import * as React from 'react';
import { useContext } from 'react';
import { ContractTableContext } from '../../ContractTableContext';

export const NoDetails = () => {
    const { emptyLabel } = useContext(ContractTableContext);

    return <div>{emptyLabel}</div>;
};
